import { Price } from '@jouzen/ecom-components/v3/Price';
import { useTranslations } from 'next-intl';

import type { Ring } from '@/app/[locale]/product/_hooks/types';
import getRingsDiscountBasePrice, {
  getRingsOldOriginalBasePrice,
  getRingsOriginalBasePrice,
} from '@/app/[locale]/product/_steps/utils/getRingsBasePrice';
import useShowOldPrice from '@/app/hooks/useShowOldPrice';
import type { RingStyle } from '@/app/types/ring';

interface BasePriceProps {
  readonly rings: Ring[] | undefined;
  readonly style: RingStyle;
}

const BasePrice = ({ rings, style }: BasePriceProps) => {
  const t = useTranslations();
  const showOldPrice = useShowOldPrice();

  //old base price is for gen3 rings that are on sale for gen4 launch
  //TODO: GROW-1607 clean up Gen3 clean up
  const oldBasePriceForRings = getRingsOldOriginalBasePrice(rings);
  const basePriceForRings = getRingsOriginalBasePrice(rings);
  const baseDiscountPriceForRings = getRingsDiscountBasePrice(rings);
  const oldBase = oldBasePriceForRings[style]?.amount ?? 0;
  const newBase = basePriceForRings[style]?.amount ?? 0;
  const discountedAmount = baseDiscountPriceForRings[style]?.amount ?? 0;
  const isDiscount = newBase - discountedAmount > 0;
  const discount = isDiscount ? newBase - discountedAmount : oldBase - newBase;
  const isFree = newBase === discount;
  let originalAmount = oldBase;

  if (isDiscount && !showOldPrice) {
    originalAmount = newBase;
  }
  const currencyCode = basePriceForRings[style]?.currencyCode;

  return (
    <>
      {!isFree && (
        <>
          <span>{t('from')}</span>&nbsp;
        </>
      )}
      <Price
        discountedPrice={{
          amount: discountedAmount,
          currencyCode: currencyCode!,
        }}
        price={originalAmount}
        priceCompare
        showZeroAsFree
      />
    </>
  );
};

export default BasePrice;
